import { Link } from 'react-router-dom';
import { hotArticles } from '@/mocks/homeData';

export default function HotArticles() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-2">
              热门爆料
            </h2>
            <p className="text-sm text-foreground-600">最新最热的吃瓜内容实时更新</p>
          </div>
          <div className="hidden sm:flex items-center gap-2">
            <button className="w-10 h-10 flex items-center justify-center rounded-full border border-background-300 text-foreground-600 hover:bg-background-100 transition-colors">
              <i className="ri-arrow-left-s-line"></i>
            </button>
            <button className="w-10 h-10 flex items-center justify-center rounded-full border border-background-300 text-foreground-600 hover:bg-background-100 transition-colors">
              <i className="ri-arrow-right-s-line"></i>
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {hotArticles.map((article, index) => (
            <Link
              key={article.slug}
              to="/category/all"
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:-translate-y-1 transition-all duration-300"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                {index === 0 && (
                  <span className="absolute top-3 left-3 bg-primary-500 text-background-50 text-xs font-medium px-2.5 py-1 rounded-full">
                    最新
                  </span>
                )}
              </div>
              <div className="p-4">
                <span className="inline-block text-xs text-primary-600 bg-primary-100/70 px-2 py-0.5 rounded-full mb-2">
                  {article.category}
                </span>
                <h3 className="text-base font-heading font-bold text-foreground-950 mb-3 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {article.title}
                </h3>
                <div className="flex items-center gap-4 text-xs text-foreground-500">
                  <span><i className="ri-eye-line mr-1"></i>{(article.views / 10000).toFixed(1)}万</span>
                  <span><i className="ri-calendar-line mr-1"></i>{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/wanghong-tafang"
            className="inline-flex items-center gap-2 px-6 py-2.5 border border-foreground-300 text-foreground-700 rounded-full text-sm font-medium hover:bg-foreground-50 transition-colors whitespace-nowrap"
          >
            查看更多爆料
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}